"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gressan": {
    "81c53061": [{
      "hkey": "06b3cddd",
      "slug": "cerise-charemoz-gerdaz-les-fleurs-plan-praz",
      "name": "Cerise-Charemoz-Gerdaz-Les Fleurs-Plan Praz",
      "primary": true,
      "skipSearch": false
    }],
    "acque-fredde-cerise-charemoz-gerdaz": [{
      "hkey": "06b3cddd",
      "slug": "cerise-charemoz-gerdaz-les-fleurs-plan-praz",
      "name": "Cerise-Charemoz-Gerdaz-Les Fleurs-Plan Praz",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;